<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 99.53 100.54"
    style="enable-background:new 0 0 99.53 100.54;"
    xml:space="preserve"
  >
    <g>
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="55.9597"
        y1="81.3574"
        x2="12.9209"
        y2="6.812"
        gradientTransform="matrix(1 0 0 -1 0 102.0194)"
      >
        <stop offset="0" style="stop-color:#EF782A" />
        <stop offset="0.2488" style="stop-color:#ED6E2E" />
        <stop offset="0.6307" style="stop-color:#EA6231" />
        <stop offset="1" style="stop-color:#EA5F32" />
      </linearGradient>
      <path
        class="st0"
        d="M57.29,21.43L0,78.72l22.14,21.81l24.01-24.01C38.54,56.99,44.42,35.15,57.29,21.43z"
      />
      <!-- <path class="st0-overlay" d="M57.29,21.43L0,78.72l22.14,21.81l24.01-24.01C38.54,56.99,44.42,35.15,57.29,21.43z"/> -->
      <rect class="st0-overlay" width="34" height="100" x="33" y="6" :style="[cssProps]" />

      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="110.4085"
        y1="95.7387"
        x2="63.5051"
        y2="14.4996"
        gradientTransform="matrix(1 0 0 -1 0 102.0194)"
      >
        <stop offset="0" style="stop-color:#F6A21C" />
        <stop offset="0.0972" style="stop-color:#F49723" />
        <stop offset="0.3275" style="stop-color:#EF7F2D" />
        <stop offset="0.5567" style="stop-color:#EC6D31" />
        <stop offset="0.7823" style="stop-color:#EB6232" />
        <stop offset="1" style="stop-color:#EA5E33" />
      </linearGradient>
      <path
        class="st1"
        d="M99.53,31.07V0c-12.8,0-24.48,4.8-33.36,12.67l-2.84,2.71c-9.07,9.76-13.73,20.82-14.07,33.7
		c-0.17,6.88,1.21,14.42,3.84,20.49c7.58,18.17,25.51,30.97,46.42,30.97V69.46c-10.6,0-19.18-8.6-19.18-19.18
		C80.35,39.67,88.94,31.07,99.53,31.07z"
      />
      <circle
        class="st2-overlay"
        :cx="50"
        :cy="0"
        :r="radius"
        :stroke-width="strokeWidth"
        :style="[cssProps]"
      />
    </g>
  </svg>
</template>

<script>
export default {
  data() {
    return {
      percentage: 50,
      circleSize: 78,
      strokeWidth: 33,
      add: false
    };
  },
  props: {
    backgroundColor: {
      type: String,
      default: "white"
    }
  },
  computed: {
    cssProps() {
      return {
        "--circumference": parseInt(this.circumference),
        "--barfill": this.barFill,
        "--background-color": this.backgroundColor
      };
    },
    circumference() {
      return parseInt((2 * Math.PI * this.radius).toFixed(0));
    },
    radius() {
      return (this.circleSize / 100) * 45;
    },
    barFill() {
      if (this.percentage > 100)
        return this.circumference - (this.circumference * 100) / 100;
      else
        return (
          this.circumference - (this.circumference * this.percentage) / 100
        );
    },
    test() {
      return this.circumference - (this.circumference * 0) / 100;
    }
  }
};
</script>

<style lang="less">
.st0 {
  fill: url(#SVGID_1_);
}
.st1 {
  fill: url(#SVGID_2_);
}
body {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
#Layer_1 {
  margin: 0 auto;
  width: 600px;
}

.st0-overlay {
  transform-origin: center center;
  transform: rotate(45deg);
  z-index: 1;
  fill: var(--background-color);
  animation: animateI infinite ease-in-out;
  animation-duration: 2.4s;
}

.st2-overlay {
  transform-origin: center center;
  z-index: 1;
  fill: none;
  stroke: var(--background-color);
  opacity: 1;
  stroke-dasharray: 221;
  stroke-dashoffset: 110.5;
  animation: animateC 2.4s infinite ease-in-out;
  transform: rotate(90deg);
}

@keyframes animateC {
  0% {
    stroke-dashoffset: 110.5;
  }
  15% {
    stroke-dashoffset: 110.5;
  }
  23% {
    stroke-dashoffset: 221;
  }
  57% {
    stroke-dashoffset: 221;
  }
  63% {
    stroke-dashoffset: 110.5;
  }
  100% {
    stroke-dashoffset: 110.5;
  }
}
@keyframes animateI {
  0% {
    height: 100px;
  }
  12% {
    height: 0px;
  }
  66% {
    height: 0px;
  }
  75% {
    height: 100px;
  }
  100% {
    height: 100px;
  }
}
</style>